module.exports = __webpack_public_path__ + "static/img/about5.8f0d082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about5.png
// module id = HrEW
// module chunks = 1